var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"main-logo"},[_c('router-link',{staticClass:"logo",attrs:{"to":"/"}},[_c('img',{staticClass:"main-logo-desktop",attrs:{"src":_vm.desktopLogoImage,"alt":"logo"}}),_c('img',{staticClass:"main-logo-mobile",attrs:{"src":_vm.mobileLogoImage,"alt":"logo"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }